import { useEffect, useMemo, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import useRynanStation from "src/hooks/useRynanStation";
import useRiver from "src/hooks/useRiver";
import useCamera from "src/hooks/useCamera";
import useDamType from "src/hooks/useDamType";
import useDams from "src/hooks/useDams";
import usePost from "src/hooks/usePost";

/**
 * AppInitializer
 * Tải dữ liệu nền ban đầu cho toàn bộ ứng dụng
 */
export default function AppInitializer({ children }: { children: React.ReactNode }) {
  const { stations, fetchStations } = useRynanStation();
  const { rivers, fetchRivers } = useRiver();
  const { cameras, fetchCameras } = useCamera();
  const { damTypes, fetchDamTypes } = useDamType();
  const { dams, fetchDams } = useDams();
  const { posts, fetchPosts } = usePost();

  const [isInitializing, setInitializing] = useState(true);

  const isLoaded = useMemo(
    () =>
      Array.isArray(stations) &&
      Array.isArray(rivers) &&
      Array.isArray(cameras) &&
      Array.isArray(damTypes) &&
      Array.isArray(dams) &&
      Array.isArray(posts),
    [stations, rivers, cameras, damTypes, dams, posts]
  );

  useEffect(() => {
    const loadAll = async () => {
      try {
        setInitializing(true);
        await Promise.allSettled([
          stations?.length ? null : fetchStations(),
          rivers?.length ? null : fetchRivers(),
          cameras?.length ? null : fetchCameras(),
          damTypes?.length ? null : fetchDamTypes(),
          dams?.length ? null : fetchDams(),
          posts?.length ? null : fetchPosts(),
        ]);
      } catch (err) {
        console.error("Error initializing app:", err);
      } finally {
        setInitializing(false);
      }
    };

    loadAll();
  }, []);

  if (isInitializing && !isLoaded) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return <>{children}</>;
}
